module.exports = {"notFound":{"ja":"メールアドレスが異なる・またはアプリ認証コードが異なっています。\n※イベントごとにアプリ認証コードが設定されています。お確かめのうえ、再度ご入力ください。","en":"The entered email address and/or the Authentication Code is incorrect.\n※Please check your information and note, the Authentication Code is different per event and sent to you via email."},"cacheError":{"ja":"サーバーエラーが発生しました。再度画面を読み込んでいただくか、時間を置いてからお試しください。","en":"Server Error.Give it some time before you try it."},"invalidToken":{"ja":"ASICS Runkeeper™との連携が切れています。もう一度、連携作業を行ってください。","en":"Your ASICS Runkeeper™ is disconnected. Please sync/connect again."}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/confirmation/alert/alert.json
// module id = YmZE
// module chunks = 1